import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { TextField} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import truckerRecordInfoStyles from './truckerRecordInfo.module.css';
import commonStyles from '../../../../common/common.module.css';
import CommonYesNoContainer from '../../../../common/commonYesNo/CommonYesNoContainer';

const styles = (theme: Theme) =>

  createStyles({
    grey: {
      color: 'rgb(0,0,0,0.26)',
    },
    blue: {
      color: 'var(--primaryblue)',
    },
    textField: {
      borderRadius: '4px',
      marginRight: '20px !important',
    },
    '@media (max-width:480px)':{
      textField:{
        marginRight: '0px !important'
      }
    }
  });
  
interface TruckerRecordInfoProps {
  classes: any;
  truckerInfo: {
    driverName: string;
    driverId: string | null;
    maskedDriverId: string | null;
    driverIDType: string | null;
    matchingPhoto: boolean | null;
  };
  loseFocus: (propertyName: string) => void;
  handleChange: (propertyName: string, event: any) => void;
  handleClick: (event: any) => void;
  setMatchingPhoto: Function;
  disabled: boolean;
};

const truckerRecordInfo = (props: TruckerRecordInfoProps) => {

  const { classes, truckerInfo, loseFocus, handleChange, handleClick } = props;

  return (
    <div className={ truckerRecordInfoStyles.inputsWrapper } >
      <Grid container>
        <Grid item md={2} className={ truckerRecordInfoStyles.grid } >
          <label className={ commonStyles.inputLabel }>Number On ID</label>
          <TextField
            variant="outlined"
            value={ truckerInfo.maskedDriverId ? truckerInfo.maskedDriverId : '' }
            onBlur={ () => loseFocus('driverId') }
            onChange={ (event) => handleChange('driverId', event) }
            InputProps={{ 
              classes: { input: classes.input }
            }}
            InputLabelProps={{
              className: truckerInfo.driverId ? classes.blue : classes.grey
            }}
            disabled={ !props.disabled }
            className={ classes.textField }
            onClick={ () => handleClick('driverId') }
            />
        </Grid>
        <Grid item md={2} className={ truckerRecordInfoStyles.grid } >
          <label className={ commonStyles.inputLabel }>Type Of ID</label>
          <TextField
            variant="outlined"
            value={ truckerInfo.driverIDType ? truckerInfo.driverIDType : '' }
            onBlur={ () => loseFocus('driverIDType') }
            onChange={ (event) => handleChange('driverIDType', event) }
            InputProps={{
              classes: { input: classes.input }
            }}
            InputLabelProps={{
              className: truckerInfo.driverIDType ? classes.blue : classes.grey
            }}
            disabled={ !props.disabled }
            className={ classes.textField }
          />
        </Grid>
        <Grid item md={3} className={ truckerRecordInfoStyles.grid } >
          <label className={ commonStyles.inputLabel }>Name</label>
          <TextField
            variant="outlined"
            value={ truckerInfo.driverName ? truckerInfo.driverName : '' }
            onBlur={ () => loseFocus('driverName') }
            onChange={ (event) => handleChange('driverName', event) }
            InputProps={{ 
              classes: { input: classes.input }
            }}
            InputLabelProps={{
              className: truckerInfo.driverName ? classes.blue : classes.grey
            }}
            disabled={ !props.disabled }
            className={ classes.textField }
          />
        </Grid>
        <Grid item md={3} className={ [truckerRecordInfoStyles.grid,truckerRecordInfoStyles.idReviewed].join(' ') } >
          <label className={ commonStyles.inputLabel }>Second ID Reviewed</label>
          <TextField
            variant="outlined"
            value='N/A'
            InputProps={{ 
              classes: { input: classes.input }
            }}
            InputLabelProps={{
              className: classes.blue
            }}
            className={ classes.textField }
          />
        </Grid>
        <Grid item md={2}className={ truckerRecordInfoStyles.grid } >
          <label className={ commonStyles.inputLabel }>Matching Photo?</label>
          <CommonYesNoContainer 
            label = { '' }
            name = { 'matchingPhoto' }
            value = { truckerInfo.matchingPhoto } 
            setValue = { props.setMatchingPhoto } 
            editable = { true }
            disabled={ props.disabled }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(truckerRecordInfo);